import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class HumanCapitalConfigurationPositionActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Hr/Position/PositionBrowser")
	}

	render() {
		return (
			<Activity 
				name="HumanCapitalConfigurationPosition"
				RenderedComponent={this.RenderedComponent}
				context="HumanCapitalConfigurationPosition"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(HumanCapitalConfigurationPositionActivity)
